import { createSelector } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";

export const PUSH = "toaster.push";
export const REMOVE = "toaster.remove";

export const DefaultStickTime = 5000;

const getToasterState = (state) => state.Toaster;
export const selectors = {
    Get: createSelector(getToasterState, (toasterState) => [
        ...toasterState.toasts,
    ]),
};

const defaultState = {
    toasts: [],
};

export const reducer = (state = defaultState, action) => {
    switch (action.type) {
        case PUSH:
            const id = uuidv4();
            //Find one that has the same type and cpty
            let newToast = {
                ...action,
                id,
                count: action.count,
            };
            // NOTE: do not group and combine new recall notifications
            if (action.pushType && action.pushType !== "recall") {
                let found = state.toasts.find(
                    (t) =>
                        t.pushType === action.pushType && t.cpty === action.cpty
                );
                if (found) {
                    newToast = {
                        ...found,
                        count: found.count + action.count,
                    };
                }
            }

            return {
                toasts: [...state.toasts, newToast],
            };

        case REMOVE:
            return { toasts: state.toasts.filter((t) => t.id !== action.id) };

        default:
            return state;
    }
};
